import { useParams, useLocation, Navigate } from "react-router-dom";

/**
 * LegacyGroupRedirect - Redirects legacy /group/* URLs to /tab/*
 * Preserves all path parameters and query strings during redirect
 */
export const LegacyGroupRedirect = () => {
  const params = useParams();
  const location = useLocation();

  // Build new path by replacing /group with /tab
  const newPath = location.pathname.replace(/^\/group/, "/tab");

  // Preserve query string and hash
  const newLocation = {
    pathname: newPath,
    search: location.search,
    hash: location.hash,
  };

  return <Navigate to={newLocation} replace />;
};
